<template>
  <div>
    <b-card class="p-0">
      <b-row>
        <b-col cols="6" class="mt-1">
          <PickCustomer ref="customers" />
        </b-col>
        <b-col cols="6">
          <div class="product-barcode-search-area">
            <div class="d-flex align-content-center align-items-center pr-2">
              <b-form-checkbox
                value="true"
                unchecked-value="false"
                v-model="isProductSearch"
              ></b-form-checkbox>
            </div>
            <div class="w-100">
              <SearchWithBarcode
                v-if="isProductSearch == 'true'"
                ref="SearchWithBarcode"
              />
              <PickProduct v-else />
            </div>
          </div>
        </b-col>
        <!-- <b-col cols="12" class="mt-1">
        <pick-warehouse />
      </b-col> -->

        <!-- <b-col cols="12" class="">
          <b-row>
            <b-col cols="2" class="mt-2">
              <h5 class="font-poppins">
                Items
              </h5>
            </b-col>
          </b-row>

          <PickProduct />
        </b-col> -->
      </b-row>
      <b-row>
        <b-col cols="12" xl="12">
          <!-- Shopping Cart -->
          <div class="mt-3" style="position: relative">
            <div>
              <!-- <table class="table table-borderless table-hover table-vcenter">
              <tbody>
                <tr>
                  <th>Product</th>
                  <th class="text-right">Price</th>
                  <th class="text-center">Qty</th>
                  <th class="text-right">Subtotal</th>
                  <th></th>
                </tr>
              </tbody>
            </table> -->
              <!-- height:40vh;min-height:38vh; -->

              <!-- PickProductUnitAndBatch -->

              <PickProductUnitAndBatch
                ref="PickProductUnitAndBatch"
                :data="selected"
                :selectedUnit="selectedUnitProp"
                :selected-batch="selectedBatchProp"
                @addProduct="editProductInBill"
                @setCurrentAmount="setCurrentAmount"
              />

              <div
                style="
                  overflow: auto;
                  overflow-x: auto;
                  min-height: calc(100vh - 240px);
                "
              >
                <!-- 420px -->
                <table class="table table-borderless table-hover table-vcenter">
                  <tbody>
                    <tr
                      v-if="services.length < 0 || products.length > 0"
                      class="bill_table_heading"
                    >
                      <th>Product</th>
                      <th class="text-center">Unit</th>
                      <th class="text-center">Qty</th>
                      <th class="text-center">Price</th>
                      <th class="text-center">Discount</th>
                      <th class="text-right">Subtotal</th>
                      <th class="text-center">
                        <i class="fa fa-trash" />
                      </th>
                    </tr>
                    <tr
                      v-for="(item, index) in products"
                      :key="index"
                      class="bill-row-added-product"
                    >
                      <td
                        @click="
                          item.productInformation
                            ? openProductModal(item, index)
                            : ''
                        "
                      >
                        {{ item.name }}
                        <!-- {{ item.isMinPriceEnabled }} -->
                      </td>
                      <!-- Unit column -->
                      <td>
                        <!-- {{item.productInformation?.units}} -->
                        <div v-if="item.productInformation">
                          <select
                            class="select"
                            v-if="
                              item.productInformation &&
                              item.productInformation.length != 0
                            "
                            v-model="item.unit"
                            @change="setBatch(item)"
                          >
                            <option
                              v-for="(unit, unitIndex) in item
                                .productInformation.units"
                              :value="unit"
                              :key="unitIndex"
                            >
                              {{ unit.name }}
                            </option>
                          </select>
                          <!-- <pre>{{ item.unit }}</pre> -->
                        </div>
                        <div v-else>
                          {{ item.unit }}
                        </div>
                      </td>
                      <td class="text-center">
                        <number-input
                          controls
                          inline
                          center
                          :min="1"
                          size="small"
                          :value="item.quantity"
                          :max="item.batch.available_stock"
                          @change="changeQuantity($event, index)"
                        />
                      </td>

                      <!-- <td class="text-right" @click="openProductModal(item, index)"> -->
                      <td class="text-right price_row">
                        <div class="font-w600 text-success amount_area">
                          <!-- {{ item.isMinPriceEnabled }} -->
                          <b-form-input
                            v-if="!item.isMinPriceEnabled"
                            class="price_input"
                            @input="onChangePrice(item)"
                            v-model="item.batch.selling_price"
                          >
                          </b-form-input>
                          <b-form-input
                            v-else
                            class="price_input"
                            @input="onChangePrice(item)"
                            v-model="item.batch.min_price"
                          >
                          </b-form-input>
                          <!-- {{ item.batch }} -->
                        </div>
                      </td>
                      <td class="text-right">
                        <!-- {{
                            item.batch && item.batch.isBargained
                              ? item.batch.bargained_amount
                              : 0 | amount
                        }} -->

                        <b-row class="discount_container m-auto">
                          <b-col cols="6" class="m-0 pr-1">
                            <b-input-group prepend="Rs" class="mb-2">
                              <b-form-input
                                @input="
                                  calculatePercentage($event, item, index)
                                "
                                ref="bargainedAmount"
                                autofocus
                                v-model="item.batch.bargained_amount"
                                placeholder="Amount"
                                type="number"
                                size="lg"
                              ></b-form-input>
                            </b-input-group>
                          </b-col>
                          <b-col cols="6" class="m-0 pl-1">
                            <b-input-group prepend="%">
                              <b-form-input
                                @input="calculateAmount($event, item, index)"
                                v-model="item.batch.bargained_percentage"
                                ref="bargainedPercentage"
                                placeholder="Percentage"
                                type="number"
                                size="lg"
                              ></b-form-input>
                            </b-input-group>
                          </b-col>
                        </b-row>
                        <div>
                          <!-- Unit list -->
                          <!-- <select class="select" v-if="item.productInformation && item.productInformation.length != 0"
                          v-model="item.unit" @change="setBatch(item)">
                          <option v-for="unit in item.productInformation.units" :value="unit">
                            {{ unit.name }}
                          </option>
                        </select> -->
                          <!-- Batch list -->
                          <!-- <select class="select" v-if="item.unit && item.unit.batches.length != 0" v-model="item.batch">
                          <option v-for="batch in item.unit.batches" :value="batch">
                            {{ batch.batch }}
                          </option>
                        </select> -->
                        </div>
                      </td>

                      <td
                        class="text-right"
                        @click="
                          item.productInformation
                            ? openProductModal(item, index)
                            : ''
                        "
                        :key="loopKey"
                      >
                        <div
                          v-if="item.isMinPriceEnabled"
                          class="font-w600 text-success amount_area"
                          :key="loopKey"
                        >
                          {{
                            (item.batch && item.batch.isBargained
                              ? (item.batch.min_price -
                                  item.batch.bargained_amount) *
                                item.quantity
                              : item.batch
                              ? item.batch.min_price * item.quantity
                              : 0) | amount
                          }}
                        </div>
                        <div v-else class="font-w600 text-success amount_area">
                          {{
                            (item.batch && item.batch.isBargained
                              ? (item.batch.selling_price -
                                  item.batch.bargained_amount) *
                                item.quantity
                              : item.batch
                              ? item.batch.selling_price * item.quantity
                              : 0) | amount
                          }}
                        </div>
                      </td>
                      <td class="text-center">
                        <b-btn
                          variant="no-decoration"
                          class="text-danger"
                          @click="removeProduct(item, index)"
                        >
                          <i class="fa fa-times" />
                        </b-btn>
                      </td>
                    </tr>
                    <tr
                      v-for="(item, index) in services"
                      :key="index"
                      class="servicearea"
                      style="border-bottom: 1px solid #c1c1c1"
                    >
                      <td colspan="3" class="text-left">
                        <i class="fa fa-briefcase service" aria-hidden="true" />
                        {{ item.name }}
                      </td>

                      <td />
                      <td class="text-right">
                        <input
                          v-model="item.amount"
                          type="number"
                          class="form-control"
                          placeholder="Amount"
                          :min="0"
                          oninput="validity.valid||(value='');"
                          style="margin-bottom: 10px; border-radius: 10px"
                          @input="changeServiceAmount(item.amount, index)"
                        />
                      </td>
                      <td class="text-center">
                        <b-btn
                          variant="no-decoration"
                          class="text-danger"
                          @click="removeService(item, index)"
                        >
                          <i class="fa fa-times" />
                        </b-btn>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div class="fixed-content">
              <table
                class="bottom-table table-borderless table-hover table-vcenter"
              >
                <tbody>
                  <tr
                    :class="'bg-success-light amt_labelss ' + loopKey"
                    :key="loopKey"
                  >
                    <td class="text-left">
                      <span class="h6 font-w600"
                        >Items {{ GetProductsCount }}</span
                      >
                    </td>
                    <td class="text-center">
                      <span class="h6 font-w600"
                        >Discount {{ GetDiscountAmount | amount }}</span
                      >
                    </td>
                    <td class="text-right">
                      <span class="h6 font-w600"
                        >Total
                        {{
                          (GetTotalAmount + GetServiceTotalAmount) | amount
                        }}</span
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- END Shopping Cart -->
          <div class="d-flex flex-column justify-content-between">
            <div />
            <!-- <div>bottom content</div> -->
          </div>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
// Models
import { BillModel, BillDecorator } from "@/models/BillModel";
// Components
import PickWarehouse from "@/components/shared/PickWarehouse";
import PickCustomer from "@/components/shared/PickCustomer";
import PickProduct from "@/components/shared/PickProduct";
import Payment from "@/components/Payment";
import SuspendSales from "@/components/SuspendSales/Index";
import ShortCutKeys from "@/mixins/ShortCutKeys";
import Qutation from "@/components/qutation/index";
import SalesReturn from "@/components/saleReturn/index";

import PickProductUnitAndBatch from "@/components/shared/PickProductUnitAndBatch";
import SearchWithBarcode from "@/components/shared/SearchWithBarcode";

export default {
  name: "BillArea",
  components: {
    PickWarehouse,
    PickCustomer,
    PickProduct,
    Payment,
    SuspendSales,
    PickProductUnitAndBatch,
    SearchWithBarcode,
    Qutation,
    SalesReturn,
  },
  mixins: [ShortCutKeys],
  data: () => ({
    // products: [],
    selected: "",
    showPopups: true,
    selectedIndex: "",
    selectedUnit: "",
    selectedBatch: "",

    //Custom select Unit & Batch
    productSelectedUnit: null,
    productSelectedBatch: null,
    result: 0,
    minPriceVisible: false,
    isProductSearch: "",
    // Loop Key
    loopKey: "",
  }),
  watch: {
    products: {
      deep: true,
      handler: function (newVal, oldVal) {
        this.setProducts(newVal);
      },
    },
    shop_info: function () {
      this.setProducts([]);
    },
  },
  computed: {
    selectedUnitProp() {
      return this.selectedUnit;
    },
    selectedBatchProp() {
      return this.selectedBatch;
    },
    ...mapState("shops", ["shop_info"]),
    ...mapState("bill", ["products"]),
    ...mapState("bill", ["services"]),
    ...mapState("auth", ["keyShortcuts"]),
    ...mapState("auth", ["help_tooltip_visible"]),
    ...mapGetters("bill", [
      "GetTotalAmount",
      "GetDiscountAmount",
      "GetServiceTotalAmount",
      "GetProductsCount",
    ]),
    // TotalAmount: function() {
    //   if (this.products.length == 0) return 0;

    //   var total = this.products.reduce(function(a, b) {
    //     return a + b.quantity * b.price;
    //   }, 0);
    //   return total;
    // },
  },
  methods: {
    openSuspendSalesModal() {
      this.$refs.openSuspendSales.showModal();
    },
    onOpenSalesReturn() {
      this.$refs.onOpenSaleReturn.showModal();
    },
    onOpenQutation() {
      this.$refs.onOpenQutation.showModal();
    },
    setBatch(data) {
      data.batch = data.unit.batches[0];
    },
    setProducts(data) {
      this.$store.commit("bill/SET_PRODUCT", data);
    },
    setUnit(event) {
      // console.log(event.target.value);
    },
    changeServiceAmount(newValue, index) {
      this.$store.commit("bill/CHANGE_SERVICE_AMOUNT", {
        amount: newValue,
        index,
      });
    },
    focusCustomerlistSearch() {
      this.$refs.customers.focusSearchCustomer();
    },
    createCustomermodal() {
      this.$refs.customers.openCustomerCreateModal();
    },
    viewCustomer() {
      this.$refs.customers.openCustomerViewModal();
    },
    changeQuantity(newValue, index) {
      this.$store.commit("bill/CHANGE_QUANTITY", {
        quantity: newValue,
        index,
      });
    },
    editProductInBill(payload) {
      const product = this.selected;
      product.unit = payload.unit;
      product.batch = payload.batch;
      product.minCurrentMoneyVisible = payload.setCurrentMoneyVisible;

      product.productInformation = payload.productInformation;

      if (payload.setCurrentMoneyVisible) {
        product.isMinPriceEnabled = true;
        product.price = payload.setCurrentMoney;
      } else {
        product.price = payload.batch.selling_price;
      }
      this.$store.commit("bill/UPDATE_PRODUCT", {
        index: this.selectedIndex,
        data: product,
      });
    },
    openProductModal(product, index) {
      this.selected = new BillDecorator(product).toRequest();
      this.selectedIndex = index;
      this.selectedUnit = product.unit;
      this.selectedUnitProp = product.unit;
      this.selectedBatch = product.batch;
      if (!this.selected.isBargained) {
        this.selected.isBargained = false;
        this.selected.bargained_percentage = 0;
        this.selected.bargained_amount = 0;
      }

      this.$refs.PickProductUnitAndBatch.disableAutoSelect(false);
      this.$refs.PickProductUnitAndBatch.showModal(
        true,
        product.isMinPriceEnabled
      );
      this.generateRandomKey();
    },
    createSuspendDraft() {
      // this.$refs.openSuspendSales.showModal();
      this.$store
        .dispatch("bill/saveSalesAsDraft")
        .then((res) => {
          this.$store.dispatch("bill/cancelBill");
          this.showToast("Sales successfully saved", "Success");
        })
        .catch((err) => {
          this.showToast("Sales failed to save", "danger");
        });
    },
    confirmationPopup() {
      this.$bvModal
        .msgBoxConfirm("Please confirm that you want to cancel everything.", {
          title: "Please Confirm",
          size: "md",
          buttonSize: "md",
          okVariant: "danger",
          okTitle: "Yes",
          cancelTitle: "No",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value) this.cancelBill();
        })
        .catch((err) => {
          // An error occurred
        });
    },
    cancelBill() {
      this.$store.dispatch("bill/cancelBill").then((res) => {
        this.showToast("Bill Cancelled", "success");
      });
    },
    showToast(message, variant = null) {
      this.$bvToast.toast(message, {
        title: "Message",
        variant,
        solid: true,
      });
    },
    openbillsection() {
      this.$refs.billsection.click();
    },
    openPaymentsection() {
      this.$refs.paysection.click();
    },
    setTabNum(value) {
      this.$store.commit("bill/SET_CUSTOMER_DISCOUNT_AMOUNT", 0);
      this.$refs.Payment.setTabNum(value);
      // if (value == 0) {
      this.$refs.Payment.setAmount(
        this.GetTotalAmount + this.GetServiceTotalAmount
      );
      this.$refs.Payment.commitPayments();
      // }
    },

    openPaymentModal() {
      this.$refs.Payment.showModal();
    },
    removeProduct(item, index) {
      this.$store.dispatch("bill/removeProduct", index);
    },
    removeService(item, index) {
      this.$store.dispatch("bill/removeService", index);
    },
    calculatePercentage(value, item, index) {
      var { batch, isMinPriceEnabled } = item;
      // item.batch.bargained_amount = value
      if (isMinPriceEnabled) {
        this.result = (batch.bargained_amount / batch.min_price) * 100;
      } else {
        this.result = (batch.bargained_amount / batch.selling_price) * 100;
      }

      if (this.result % 1 == 0) {
        batch.bargained_percentage = this.result;
        batch.isBargained = true;
        if (this.$refs.bargainedPercentage.length > 0) {
          this.$refs.bargainedPercentage[index].value = this.result;

          // this.$refs.bargainedPercentage.forEach((item) => {
          //   batch.value = this.result;
          // });
        } else {
          this.$refs.bargainedPercentage.value = this.result;
        }
        // this.selectedUnit.batches[index].bargained_percentage = result;
      } else {
        batch.bargained_percentage = this.result.toFixed(2);
        batch.isBargained = true;
        if (this.$refs.bargainedPercentage.length > 0) {
          this.$refs.bargainedPercentage[index].value = this.result;
          // this.$refs.bargainedPercentage.forEach((item) => {
          //   batch.value = this.result;
          // });
        } else {
          this.$refs.bargainedPercentage.value = this.result;
        }
      }
      this.generateRandomKey();
    },
    calculateAmount(value, item, index) {
      var { batch, isMinPriceEnabled } = item;

      // batch.batch.bargained_percentage = value;
      if (isMinPriceEnabled) {
        var amount = (batch.bargained_percentage * batch.min_price) / 100;
      } else {
        var amount = (batch.bargained_percentage * batch.selling_price) / 100;
      }
      batch.bargained_amount = amount;
      batch.isBargained = true;

      if (this.$refs.bargainedAmount.length > 0) {
        this.$refs.bargainedAmount[index].value = amount;
        // this.$refs.bargainedAmount.forEach((items, index) => {
        //   if (discountIndex == index) {
        //     items.value = amount;
        //   }
        // });
      } else {
        this.$refs.bargainedAmount.value = amount;
      }
      this.generateRandomKey();
    },
    onChangePrice(item) {},
    generateRandomKey(length = 5) {
      var result = "";
      var characters =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      var charactersLength = characters.length;
      for (var i = 0; i < length; i++) {
        result += characters.charAt(
          Math.floor(Math.random() * charactersLength)
        );
      }

      // console.log("LoopKey: ", result);
      this.loopKey = result;
    },
    setCurrentAmount(payload) {
      const { value, data } = payload;

      this.products[this.selectedIndex].isMinPriceEnabled = value;
      this.products[this.selectedIndex].batch.bargained_percentage = 0;
      this.products[this.selectedIndex].batch.bargained_amount = 0;

      // console.log(this.products[this.selectedIndex]);

      // debugger;
      // if (this.$refs.bargainedPercentage.length > 0) {
      //   this.$refs.bargainedPercentage[this.selectedIndex].value = 0;
      // } else {
      //   this.$refs.bargainedPercentage.value = 0;
      // }
      this.generateRandomKey();
    },
  },
};
</script>
<style>
.bill_table_heading {
  background-color: #fbfbfb;
  color: white;
  border: 1px solid #ebebeb;
}

.bill_table_heading:hover {
  background-color: #fbfbfb !important;
  color: white !important;
}

.bill_table_heading th:hover {
  background-color: #fbfbfb;
}

.bill_table_heading th {
  padding: 3px 5px;
  text-align: left;
  font-size: 16px;
  color: #087592;
  font-weight: 700 !important;
}

.amt_labelss td {
  padding: 3px 40px;
  text-align: left;
  font-size: 12px;
  background-color: #ffffff;
  border-top: 1px solid #bfbcbc;
}

.amt_labelss span {
  font-size: 14px;
  color: #087592;
}

.number-input--small.number-input--inline > input {
  width: 110px !important;
}

.bill_buttons button {
  border-radius: unset !important;
  border-radius: 12px;
}

.payment_btn {
  border-radius: unset;
  padding: 14px;
  width: 177px;
}

.amount_area {
  width: 75px;
}

.servicearea {
  /* background: #fbecee; */
}

.clear_button {
  color: #f18299;
  background: #fbecee;
  border-color: #fbecee;
}

.clear_button:hover,
.clear_button:active {
  color: #f26381 !important;
  background: #ffe2e6 !important;
  border-color: #ffe2e6 !important;
}

.fixed-content {
  bottom: 0;
  left: 0;
  padding: 0;
  position: sticky;
  width: 100%;
  z-index: 1;
}

.nuxt-container {
  height: 100% !important;
}

* {
  scrollbar-width: thin;
}

*::-webkit-scrollbar {
  width: 12px;
}

*::-webkit-scrollbar-thumb {
  border-radius: 20px;
}

.service {
  border-bottom: 1px solid #eee;
  font-size: 22px;
  margin-top: 11px;
}

.select {
  padding: 4px 5px;
  border-radius: 5px;
  border-color: #ebebeb;
  margin: 0 5px;
  padding: 10px;
  width: 100%;
}

.bill-row-added-product td {
  border-bottom: 1px solid #c1c1c1;
  border: 1px solid #ebebeb;
  background-color: #ffffff;
  color: #087592;
  font-weight: 600;
  font-size: 12px;
}

.bottom-table {
  margin-bottom: 0px !important;
}

.card-body {
  padding-bottom: 0px !important;
  box-shadow: 0px 14px 40px rgba(109, 141, 173, 0.25);
}

.payment-buttons {
  margin-top: 16px;
  display: flex;
}

.draft_btn {
  background-color: #56bdea;
  border-color: #56bdea;
}

.quotation_button {
  background-color: #f3b15a;
  border-color: #f3b15a;
}

.suspend_button {
  background-color: #e2495f;
  border-color: #e2495f;
}

.sales_return_button {
  background-color: #4574e9;
  border-color: #4574e9;
}

.cancel_button {
  background-color: #56bdea;
  border-color: #56bdea;
}

.totalPayable_button {
  background-color: #081e3d;
  border-color: #081e3d;
}

.payment-buttons .btn {
  width: 140px !important;
  height: 40px !important;
  margin: 0 4px;
}

.cancel_button {
  background-color: #e2495f;
  border-color: #e2495f;
}

.recentTransaction_button {
  width: 177px;
  background-color: #3570e0;
  border-color: #3570e0;
}

.discount_container {
  width: 300px;
}

.price_row {
  width: 150px;
}

.price_input {
  width: 130px;
  margin: auto;
}

.product-barcode-search-area {
  display: flex;
}
</style>
